import * as React from 'react';
export var isClientSide = typeof document === 'object';
export var useSSRLayoutEffect = isClientSide
    ? React.useLayoutEffect
    : React.useEffect;
//# sourceMappingURL=ssr.js.map